/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerstoryfailed3Inputs */

const en_checkinflyerstoryfailed3 = /** @type {(inputs: Checkinflyerstoryfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The story image could not be created.`)
};

const de_checkinflyerstoryfailed3 = /** @type {(inputs: Checkinflyerstoryfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Story-Bild konnte nicht erstellt werden.`)
};

/**
* | output |
* | --- |
* | "The story image could not be created." |
*
* @param {Checkinflyerstoryfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerstoryfailed3 = /** @type {((inputs?: Checkinflyerstoryfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerstoryfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerstoryfailed3(inputs)
	return de_checkinflyerstoryfailed3(inputs)
});
export { checkinflyerstoryfailed3 as "checkinFlyerStoryFailed" }